//
// Copyright © 2026 Hardcore Engineering Inc.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//

import { type Plugin, type Resource, plugin } from '@hcengineering/platform'
import type { DocCreateFunction } from '@hcengineering/presentation'
import type { AnyComponent } from '@hcengineering/ui'

/**
 * Task type custom fields on issue creation.
 *
 * A task type keeps its user defined fields as `core.class.Attribute` on the mixin named by
 * `TaskType.targetClass`. The tracker's create dialog never touches that mixin, so a freshly
 * created issue carries no mixin data at all, and the detail panel only renders mixins the
 * document actually has. The fields are therefore invisible on everything made from the UI.
 *
 * This plugin fills the gap through `presentation.class.DocCreateExtension`, so no tracker
 * file has to be modified.
 *
 * @public
 */
export const taskfieldsId = 'taskfields' as Plugin

const taskfields = plugin(taskfieldsId, {
  component: {
    CreateIssueCustomFields: '' as AnyComponent
  },
  function: {
    ApplyTaskTypeMixin: '' as Resource<DocCreateFunction>
  }
})

export default taskfields
